export  enum VendorCommandsEnum {
    TOGGLE_SOUND_CONTROLLER = "TOGGLE_SOUND_CONTROLLER",
    TOGGLE_SOUND_BUTTON = "TOGGLE_SOUND_BUTTON",
    TOGGLE_MASTER_SOUND_BUTTON = "TOGGLE_MASTER_SOUND_BUTTON",
    UPDATE_JACKPOTS = "UPDATE_JACKPOTS",
    TOGGLE_JACKPOTS_BUTTON = "TOGGLE_JACKPOTS_BUTTON",
    SHOW_INSUFFICIENT_FUNDS_MESSAGE = "SHOW_INSUFFICIENT_FUNDS_MESSAGE",
    GAME_PAUSED = "GAME_PAUSED",
    BALANCE_UPDATE = "BALANCE_UPDATE",
    FEATURE_BUTTON_OPTIONS = "FEATURE_BUTTON_OPTIONS"
}
